import { jsx as _jsx } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { T } from '@sm/intl';
import { Banner } from '@wds/banner';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
const COPY = {
  SurveyUpdatedDescription: {
    id: 'buildWithAI.SurveyUpdatedBanner.SurveyUpdatedDescription',
    defaultMessage: '<b>Survey updated! Your prompt was:</b> “{prompt}”',
    description: '[Type: Label][Vis: high] - inform user their survey was updated and display the prompt they used to modify the survey'
  }
};
const useStyles = createUseStyles(theme => ({
  container: {
    '& b': {
      fontWeight: '500'
    }
  }
}));
const SurveyUpdatedBanner = ({
  prompt,
  show
}) => {
  const {
    container
  } = useStyles();
  return _jsx(Banner, {
    color: "success",
    dismissible: true,
    show: show,
    children: _jsx(Box, {
      className: container,
      display: "flex",
      children: _jsx(Typography, {
        children: _jsx(T, {
          desc: COPY.SurveyUpdatedDescription,
          values: {
            prompt: prompt
          },
          html: true
        })
      })
    })
  });
};
export default SurveyUpdatedBanner;